export default () => {
    let open = document.querySelector('.open-menu-js');
    let close = document.querySelector('.close-menu-js');
    let mobileMenu = document.querySelector('.mobile-menu');
    let parents = mobileMenu.querySelectorAll('li.menu-item-has-children');
    let expander = '<a class="expand-trigger" href="#"><i class="fa fa-chevron-down"></i></a>';

    open.addEventListener('click', function (e) {
        mobileMenu.classList.add('open');
    });

    close.addEventListener('click', function (e) {
        mobileMenu.classList.remove('open');
    });

    for (let i = 0; i < parents.length; i++) {
        parents[i].insertAdjacentHTML('beforeend', expander);
    }

    let expandTriggers = mobileMenu.querySelectorAll('.expand-trigger');
    for (let i = 0; i < expandTriggers.length; i++) {
        expandTriggers[i].addEventListener('click', function (e) {
            e.preventDefault();
            expandTriggers[i].parentElement.classList.toggle('open');
        });
    }
}